import * as React from "react";
import cx from "classnames";
import stylesV2 from "./LegacyCard.module.scss";
import stylesV3 from "./LegacyCardV2.module.scss";
import { useSchedulingABVariant } from "../../features/scheduling/utils/useSchedulingABVariant";

type LegacyCardTheme = "desktopOnly";

type LegacyCardProps = {
  children?: React.ReactNode;
  className?: string;
  theme?: LegacyCardTheme;
};

export const LegacyCard: React.FC<LegacyCardProps> = ({
  children,
  className,
  theme,
}) => {
  const { isV3 } = useSchedulingABVariant();
  const styles = isV3 ? stylesV3 : stylesV2;

  return (
    <section
      className={cx(styles.card, className, {
        [styles.desktopOnly]: theme === "desktopOnly",
      })}
    >
      {children}
    </section>
  );
};
